<template>
  <div class="category-selector">
    <v-overlay
      :value="displayDialog"
      class="align-center justify-center white-overlay"
    >
      <v-dialog persistent :hide-overlay="true" content-class="overflow-visible filter-dialog" v-model="displayDialog" width="400">
        <v-card class="px-7 py-7 overflow-visible filter-dialog">
          <v-btn @click="displayDialog = false" absolute fab x-small class="filtering-modal-close-button" dark top><v-icon>mdi-close</v-icon></v-btn>
          <div class="H1">
            {{ title }}
          </div>
          <div>
            <div class="H3 grey-2--text my-2">{{ $t('upcoming_events.select_prompt') }}</div>
            <v-layout justify-end class="mb-3">
              <v-btn @click="selectAll" small text class="no-uppercase px-2" color="primary lighten-1">{{$t('upcoming_events.actions.select_all')}}</v-btn>
              <v-btn @click="deselectAll" small text class="no-uppercase px-2" color="primary lighten-1">{{$t('upcoming_events.actions.deselect_all')}}</v-btn>
            </v-layout>
            <div class="category-button-container">
              <v-btn
                v-for="(category, i) in categories" :key="i"
                @click="changeSelection(category)"
                class="no-uppercase filtering-chip"
                small
                outlined
                :color="category.selected ? 'primary lighten-1' : 'grey-2'">
                <v-icon class="material-symbols-rounded" v-if="category.selected">check_circle_outline</v-icon>
                <span>{{ category.name }}</span>
              </v-btn>
            </div>
            <v-layout justify-end class="mt-7">
              <v-btn @click="save" small class="filtering-modal-save-button" color="primary lighten-1">
                {{ $t('actions.save') }}
              </v-btn>
            </v-layout>
          </div>
        </v-card>
      </v-dialog>
    </v-overlay>
    <div
      @click="displayDialog = true">
      <v-autocomplete
        v-if="activityCategories"
        disabled
        :items="activityCategories"
        solo
        multiple
        chips
        item-value="id"
        v-model="selectedCategories"
        prepend-inner-icon="sort"
        :menu-props="{ openOnClick: false }"
        class="category-selector"
        :label="selectedCategories.length ? '' : $t('upcoming_events.select_categories')"
      >
        <template v-slot:append>
          <v-icon class="material-symbols-rounded primary--text text--darken-1">expand_more</v-icon>
        </template>
        <template v-slot:selection="{ item, index }">
          <span v-if="index <= 1" class="selected-categories">
            <span v-if="index > 0 && index < selectedCategories.length">, </span>
            {{ item.name }}
          </span>
          <v-flex
            v-if="index === 2"
            class="grey--text caption text-right selected-categories mr-2"
            style="order: 1;"
          > +{{ selectedCategories.length - 2 }} {{$t('upcoming_events.more')}}</v-flex>
        </template>
      </v-autocomplete>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
export default {
  data () {
    return {
      displayDialog: false,
      selectedCategories: localStorage.getItem('upcomingEventCategories') ? JSON.parse(localStorage.getItem('upcomingEventCategories')) : [],
      pendingSelectedCategories: localStorage.getItem('upcomingEventCategories') ? JSON.parse(localStorage.getItem('upcomingEventCategories')) : [],
    }
  },
  methods: {
    changeSelection (category) {
      const categoryIndex = this.pendingSelectedCategories.findIndex((id) => { return category.id === id })
      if (categoryIndex < 0) {
        this.pendingSelectedCategories.push(category.id)
      } else {
        this.pendingSelectedCategories.splice(categoryIndex, 1)
      }
    },
    selectAll () {
      this.pendingSelectedCategories = this.categories.map((c) => { return c.id })
    },
    deselectAll () {
      this.pendingSelectedCategories = []
    },
    save () {
      localStorage.setItem('upcomingEventCategories', JSON.stringify(this.pendingSelectedCategories))
      this.$emit('selectedCategories', this.pendingSelectedCategories)
      this.displayDialog = false
    },
  },
  computed: {
    ...mapGetters({ 
      getDashboardName: 'pages/getDashboardName',
    }),
    ...mapState({
      activityCategories: state => state.activities.categories.filter((c) => !c.excludeFromFeaturedNextOn),
    }),
    categories () {
      let categories = this.activityCategories.map((c) => { return { ...c, selected: !!this.pendingSelectedCategories.find((id) => id === c.id) } })
      return categories
    },
    displayCategories () {
      this.selectedCategories.map((id) => { return this.activityCategories.find((c) => c.id === id) })
      return this.selectedCategories.map((id) => { return this.activityCategories.find((c) => c.id === id) })
    },
    title () {
      return this.getDashboardName({ routeName: this.$route.name })
    },
  },
  created () {
    this.$store.dispatch('activities/listCategories')
  },
  watch: {
    displayDialog () {
      if (!this.displayDialog) {
        this.selectedCategories = localStorage.getItem('upcomingEventCategories') ? JSON.parse(localStorage.getItem('upcomingEventCategories')) : []
        this.pendingSelectedCategories = localStorage.getItem('upcomingEventCategories') ? JSON.parse(localStorage.getItem('upcomingEventCategories')) : []
      }
    },
  },
}
</script>
<style lang="scss">
.filtering-chip {
  padding: 8px 10px !important;
  height: 36px !important;
  border: 2px solid;
  .v-btn__content {
    font-family: 'Urbanist';
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px;
    letter-spacing: 0.25px;
  }
  .v-icon {
    margin-right: 10px;
  }
}
.category-selector .v-input__icon.v-input__icon--prepend-inner > .v-icon {
  color: var(--v-primary-lighten1) !important;
  font-size: 18px;
}
.category-selector .v-input__slot {
  box-shadow: 0px 0px 28px 0px rgba(0, 0, 0, 0.10) !important;
  border-radius: 10px;
}
.category-selector .v-label {
  color: var(--v-primary-darken1);
  font-family: 'Mukta Mahee';
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.25px;
}
.selected-categories {
  color: var(--v-grey-2-base);
  font-family: 'Mukta Mahee';
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.25px;
}
.category-button-container {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  gap: 10px 12px;
}
.filtering-modal-close-button {
  right: -16px;
  width: 42px !important;
  height: 42px !important;
  border: 5px solid white;
  color: white;
  background-color: var(--v-primary-lighten1) !important;
  .v-icon {
    font-size: 24px !important;
  }
}
.filtering-modal-save-button {
  padding: 10px 15px !important;
  height: 40px !important;
  .v-btn__content {
    color: #FFF;
    text-align: center;
    font-family: 'Urbanist';
    font-size: 15px;
    font-style: normal;
    font-weight: 700;
    line-height: 15px;
    letter-spacing: 1.25px;
  }
}
.filter-dialog {
  border-radius: 10px !important;
  background: #FFF;
  box-shadow: 0px 0px 28px 0px rgba(0, 0, 0, 0.10);
}
</style>